module.exports = __webpack_public_path__ + "img/Icon_Bin_gray.e5d68d3c.svg";